import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { UtilService } from 'src/app/shared/services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'testing',
  standalone: true,
  imports: [CommonModule, YouTubePlayerModule],
  templateUrl: './testing.component.html',
  styleUrls: ['./testing.component.scss']
})
export class TestingComponent implements OnInit {

  player;

  constructor(
    public util: UtilService
  ) { }

  ngOnInit(): void {
    if (environment.production && this.util.isBrowser) {
      setTimeout(() => {
        const list = ['x4OTM9pqLw8', 'VEFT358NWYk', 'Pa8He365hbg', 'vaSMXXgb-sI', 'j6roxDBMxZQ', 'Ph7EmEkQwHc', 'xLJ0PLgk_tc', 'gqmT_IVW2Nc', 'J4lthNMBugM', 'PU31-hB0RC8', '9N2Wdmt5Q9w', 'Jy6x-NqEPpc', 'sP_5-840apM', '3Zvjfb8ZEco'];
        const pos = Math.floor(Math.random() * list.length);
        const setAnyOne = list[pos];
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.body.appendChild(tag);
        window['onYouTubeIframeAPIReady'] = () => this.onYouTubeIframeAPIReady(setAnyOne);
      }, 100);
    }
  }


  onYouTubeIframeAPIReady(id) {
    this.player = new YT.Player('test-player', {
      width: '100px',
      height: '60px',
      playerVars: { autoplay: 0, rel: 0, controls: 1, modestbranding: 1, iv_load_policy: 3, showinfo: 0, loop: 0 },
      videoId: id,
      events: {
        'onReady': this.onPlayerReady.bind(this),
        'onStateChange': this.onPlayerStateChange.bind(this)
      }
    });
  }

  onPlayerReady() {
    setTimeout(() => {
      this.player.playVideo();
      this.player.mute();
    }, 100);
  }

  onPlayerStateChange(event) {
    // console.log(event);
  }

}